import { z } from 'zod';
import { IntegrationType } from 'libs/end-to-end/src/types/databases/integrations/integration-type';

export const BaseIntegration = z.object({
  integrationType: IntegrationType,
});

export type BaseIntegration = z.infer<typeof BaseIntegration>;
